import { useState } from "react";
import {
  NameUser,
  NicNameUserColor,
  ButtonContantUs,
  ButtonLocalData,
  ButtonMainInfo,
  ButtonSecurity,
  ContainerButton,
  ContainerLanguagesPage,
  HeaderLanguagePage,
  Languages,
  LanguagesPageContainer,
  TitlePage,
  TitlePageMobile,
  ButtonCredits,
} from "./LanguagesPageStyles.styled";
import { NavLink } from "react-router-dom";
import { useLanguageContext } from "../../../Components/Languages/Langs/LanguageContext";
import useAuth from "../../../Redux/useAuth";
import { ModelWindow } from "../../../Components/ModelWindow/ModelWindow";
import { ButtonBackPage } from "../../MainInfo/MainInfoStyles.styled";
import { ButtonBackPageIcon } from "../../MainInfo/Icons/Icons";
import { Swicher } from "./Swicher/Swicher";
import { Logout } from "../../../Components/ModelWindows/Logout/Logout";
import { ButtonLogOut } from "../../../Components/ModelWindows/Logout/LogOut.styled";

export const LanguagesPage = () => {
  const { user } = useAuth();
  const { t } = useLanguageContext();

  const [openModelLogOut, setOpenModelLogOut] = useState(false);
  const [showLogOut, setShowLogOut] = useState(false);
  const [value, setValue] = useState("EN");

  const openLogOut = () => {
    setShowLogOut(true);
    setTimeout(() => setOpenModelLogOut(true), 0);
  };

  const closeLogOut = () => {
    setOpenModelLogOut(false);
    setTimeout(() => setShowLogOut(false), 250);
  };

  return (
    <>
      <HeaderLanguagePage>
        <ButtonBackPage to={`/home-page/${user?.name?.toLowerCase()}`}>
          <ButtonBackPageIcon />
        </ButtonBackPage>
        <NameUser>
          {t("privateTraslate.privateHeaderNameUser")}
          <NicNameUserColor> {user?.name || "User"}</NicNameUserColor>
        </NameUser>
        <TitlePage>{t("privateTraslate.languagesPage")}</TitlePage>
      </HeaderLanguagePage>

      <ContainerLanguagesPage>
        <ContainerButton>
          <NavLink to={`/home-page/${user?.name?.toLowerCase()}/main-info`}>
            <ButtonMainInfo>
              {t("privateTraslate.updateDataUserPageTitle")}
            </ButtonMainInfo>
          </NavLink>

          <NavLink to={`/home-page/${user?.name?.toLowerCase()}/security-page`}>
            <ButtonSecurity>
              {t("privateTraslate.securityPageTitle")}
            </ButtonSecurity>
          </NavLink>

          <NavLink to={`/home-page/${user?.name?.toLowerCase()}/languages`}>
            <Languages>{t("privateTraslate.languagesPageTitle")}</Languages>
          </NavLink>

          {/* <NavLink to={`/home-page/${user?.name?.toLowerCase()}/modes`}>
            <ButtonModes>{t("privateTraslate.ModesPage")}</ButtonModes>
          </NavLink> */}

          <NavLink to={`/home-page/${user?.name?.toLowerCase()}/local-data`}>
            <ButtonLocalData>
              {t("privateTraslate.LocalDataPage")}
            </ButtonLocalData>
          </NavLink>

          <NavLink to={`/home-page/${user?.name?.toLowerCase()}/contacts`}>
            <ButtonContantUs>
              {t("privateTraslate.contactUsPageTitle")}
            </ButtonContantUs>
          </NavLink>
          <NavLink to={`/home-page/${user?.name?.toLowerCase()}/credits`}>
            <ButtonCredits>{t("privateTraslate.ButtonCredit")}</ButtonCredits>
          </NavLink>

          <ButtonLogOut onClick={openLogOut}>
            {t("privateTraslate.logOutButton")}
          </ButtonLogOut>
        </ContainerButton>
        <LanguagesPageContainer>
          <TitlePageMobile>
            {t("privateTraslate.languagesPage")}
          </TitlePageMobile>
          <Swicher value={value} setValue={setValue} />
        </LanguagesPageContainer>

        {showLogOut && (
          <ModelWindow onClose={closeLogOut} isOpen={openModelLogOut}>
            <Logout onClose={closeLogOut} />
          </ModelWindow>
        )}
      </ContainerLanguagesPage>
    </>
  );
};
